import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { DividerSection } from '../../../global/components/layout/divider-section';
import { TcsmStates } from '../../../root/tcsm-model';
import { ClergyBioSettings } from '../../arc/models/arc-epi-props';
import { ClergyBioChurchVolunteer, ClergyBioRoutes, ClergyBioVolunteer, DataState, InstitutionInfo } from '../model/clergy-bio-app-models';
import ClergyBioComponentLoader from '../components/clergy-bio-component-loader';
import { sortTableStyles } from '../../../global/constants/theme/styles/tables/generic-sort-table';
import { ContentSpacer } from '../../../global/components/layout/generic-content-spacer';
import { WysiwygWithReactLink } from '../../../global/components/wysiwyg-with-react-link';
import { buttonStyles } from '../../../global/constants/theme/styles/components/buttonstyles';
import { headerIconStyles } from '../../../global/constants/theme/styles/components/header-icon-styles';
import { ClericIcon } from '../../account-info/components/cleric-indicator';

interface Props {
	settings: ClergyBioSettings;
	basePath: string;
}

function ClergyBioVolunteerReview(props: Props) {
	const tableClasses = sortTableStyles();
	const { settings, basePath } = props;
	const loadingState = useSelector<TcsmStates, DataState>(state => state?.clergyBioState?.loaded?.volunteer);
	const volunteer = useSelector<TcsmStates, ClergyBioChurchVolunteer>(state => state?.clergyBioState?.volunteer);
	const buttonClasses = buttonStyles();
	const headerClasses = headerIconStyles();

	function Labels() {
		return (
			<div className='sort-table-row'>
				<div className='sort-table-row-cell'><p><strong>{settings?.startLabel}</strong></p></div>
				<div className='sort-table-row-cell'><p><strong>{settings?.endLabel}</strong></p></div>
				<div className='sort-table-row-cell'><p><strong>{settings?.institutionLabel}</strong></p></div>
				<div className='sort-table-row-cell'><p><strong>{settings?.positionLabel}</strong></p></div>
			</div>
		);
	}

	function TableRow(e: ClergyBioVolunteer) {
		return (
			<div className='sort-table-row' key={e?.id} >
				<div className='sort-table-row-cell'>{e?.dateBegan}</div>
				<div className='sort-table-row-cell'>{e?.dateEnded}</div>
				<div className='sort-table-row-cell'>{(e?.institutionInfo as InstitutionInfo)?.name || e?.institutionInfo}</div>
				<div className='sort-table-row-cell'>{e?.position}</div>
			</div>
		);
	}
	function RenderContent() {
		return (
			<>
				<div className={headerClasses.iconHeader}>
					<ClericIcon />
					<h3>{settings?.episcopalVolunteerTitle}</h3>
				</div>
				<ContentSpacer>
					{
						volunteer?.episcopal?.details?.length > 0 ?
							<div className={tableClasses.sortTable}>
								<Labels />
								<div className='sort-table-content'>
									{
										volunteer?.episcopal?.details?.map(v => TableRow(v))
									}
								</div>
							</div> :
							<WysiwygWithReactLink content={settings?.noInformationText} />
					}
				</ContentSpacer>
				<div className={headerClasses.iconHeader}>
					<ClericIcon />
					<h3>{settings?.miscellaneousVolunteerTitle}</h3>
				</div>
				<ContentSpacer>
					{
						volunteer?.miscellaneous?.details?.length > 0 ?
							<div className={tableClasses.sortTable}>
								<Labels />
								<div className='sort-table-content'>
									{
										volunteer?.miscellaneous?.details?.map(v => TableRow(v))
									}
								</div>
							</div> :
							<WysiwygWithReactLink content={settings?.noInformationText} />
					}
				</ContentSpacer>
			</>
		);
	}

	return (
		<DividerSection sectionText={settings?.volunteerTitle} >
			<ClergyBioComponentLoader
				state={loadingState}
				content={<RenderContent />}
			/>
			<ContentSpacer>
				<Link className={buttonClasses.primaryButton} to={`${basePath}${ClergyBioRoutes.Volunteer}`}>{settings?.updateButtonText}</Link>
			</ContentSpacer>
		</DividerSection>
	);
}


export default ClergyBioVolunteerReview;